export default "__VITE_ASSET__CG_T4yJx__"